<template>
  <div>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ $t('dishes.section') }}</div>
      <v-spacer />
      <div class="d-flex justify-end">
        <div class="mr-3">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar por nombre"
            solo
            hide-details
            rounded
            flat
            dense
          />
        </div>
        <v-btn v-if="!locked"
          color="primary"
          rounded
          small
          depressed
          :loading="overlay"
          @click="update">
          Generar stock
        </v-btn>
      </div>
    </div>

    <v-flex xs12>
      <div v-if="overlay">
        <v-skeleton-loader type="table-heading, table-tbody"/>
      </div>
      <v-form v-else ref="prospections" v-model="isValid">
        <v-data-table
          :loading-text="table.title"
          :server-items-length="table.total"
          :no-data-text="table.noDataText"
          :headers="table.headers"
          :items="table.data.models"
          :options="table.options"
          :footer-props="{
            'items-per-page-options': [10, 20, 30, 40, 50]
          }"
          :sort-by="sortAttrName"
          show-select
          item-key="uuid"
          v-model="selected"
          @toggle-select-all="onToggleSelect"
          @update:options="updateTable"
          @update:sort-by="sortByTable"
          @update:sort-desc="sortDescTable"
          class="elevation-1 fixed-header">
          <template v-slot:top>
            <div class="px-3 filters">
              <v-row>
                <v-col md="3">
                  <div class="d-flex align-center">
                    <span class="mr-3">
                      Filtros:
                    </span>
                    <v-select
                      v-model="sectionSelected"
                      :items="sections"
                      item-value="id"
                      item-text="name"
                      label="Sección"
                      hide-details
                      return-object
                      dense
                      @change="filterBySection"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
          </template>
          <template v-slot:item.uuid="{ item }">
            <v-checkbox v-model="item.checked"/>
          </template>
          <template v-slot:item.name="{ item }">
            <a href="" @click.prevent="openUpdateIngredientsDialog(item)">
              {{ item.name }}
            </a>
          </template>
          <template v-slot:item.cost="{ item, header }">
            <template v-if="header.meta !== 'percent'">
              <div class="text-right">
                {{ item.cost | toFix2 | numberWithComma }}
              </div>
            </template>
            <template v-else>
              <div style="max-width: 100px">
                <v-text-field
                  @input="calculatePrice($event, item)"
                  :value="item.percent"
                  :rules="rules.numberValid"
                  @update:error="setError('percent', item, $event)"
                />
              </div>
            </template>
          </template>
          <template v-slot:item.avgWeeklySale="{ item }">
            <div class="text-right">
              {{ item.avgWeeklySale | toFixNumber(2) | numberWithComma }}
            </div>
          </template>
          <template v-slot:item.quantity="{ item }">
            <div style="max-width: 100px">
              <v-text-field
                type="number"
                v-model.number="item.quantity"
                @input="changeItemQuantity($event, item)"
                :rules="rules.numberValid"
                @update:error="setError('quantity', item, $event)"
              />
            </div>
          </template>
          <template v-slot:item.price="{ item }">
            <div style="max-width: 100px">
              <v-text-field
                @input="calculatePercent($event, item)"
                :value="item.price"
                :rules="rules.numberValid"
                @update:error="setError('price', item, $event)"
              />
            </div>
          </template>
        </v-data-table>
      </v-form>
      <v-alert
        class="mt-4"
        v-if="table.data <= 0 && !overlay"
        type="info"
        dense
      >
        No se encontraron productos, intenta seleccionando otra área
      </v-alert>
    </v-flex>

    <!-- <v-dialog v-model="lockedDialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Prospección en proceso</span>
        </v-card-title>
        <v-card-text>
          Actualmente el usuario <b>{{ prospectingSession.author.email }}</b> está prospectando el area <b>{{ $store.state.area.name }}</b>. Si desea continuar finalice la prospección actual o elija otra area.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" text @click="lockedDialog = false">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <v-dialog @keydown.esc="missingAreaDialog=false" v-model="missingAreaDialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Area no establecida</span>
        </v-card-title>
        <v-card-text>
          Elije una area para continuar.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" text @click="missingAreaDialog = false">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ingredientsDialog
      :recipe="recipe"
      :ingredientDialog="ingredientDialog"
      @closeIngredientDialog="closeIngredientDialog"/>
  </div>
</template>

<script>
import ingredientsDialog from '@/components/sidePanels/RecipeDetail'
import Recipe from '@/models/Recipe'
import Prospection from '@/models/Prospection'
import Order from '@/models/Order'
import RecipesList from '@/models/collections/RecipesList'
import _ from 'lodash'

export default {
  name: 'Dishes',
  components: { ingredientsDialog },
  data () {
    let recipesList = new RecipesList()
    let recipeModel = new Recipe({}, recipesList)
    let prospection = new Prospection()
    let orderModel = new Order()

    return {
      channel: null,
      percentageSuggestedQuantity: 1.1,
      selected: [],
      recipeModel,
      recipesList,
      prospection,
      orderModel,
      search: '',
      sectionSelected: { name: 'Todas' },
      isValid: false,
      missingAreaDialog: false,
      ingredientDialog: false,
      lockedDialog: false,
      overlay: false,
      section: this.$i18n.t('dishes.section'),
      sortAttrName: 'name',
      prospectingSession: { author: {} },
      locked: false,
      dishes: [],
      recipe: { uuid: null, cost: null },
      table: {
        title: this.$i18n.t('dishes.loading'),
        noDataText: 'No se encontraron productos, intenta seleccionando otra área',
        loading: true,
        headers: [
          { text: this.$i18n.t('dishes.headers.name'), value: 'name' },
          { text: this.$i18n.t('dishes.headers.section'), value: 'section.name' },
          // { text: this.$i18n.t('dishes.headers.avgWeeklySale'), value: 'avgWeeklySale' },
          { text: this.$i18n.t('dishes.headers.quantity'), value: 'quantity' }
        ],
        data: [],
        total: 0,
        options: {
          itemsPerPage: 50,
          page: 1
        }
      },
      errors: [],
      rules: {
        numberValid: [
          v => (v !== '' && !isNaN(v * 1)) || this.$t('validations.numberValid')
        ]
      }
    }
  },
  beforeMount () {
    // const channelName = `${this.$store.state.currentRestaurant.data._id}-${this.$store.state.login.user._id}-channel`
    // this.channel = this.$pusher.subscribe(channelName)
  },
  async mounted () {
    if (!this.$store.state.area.id) {
      this.missingAreaDialog = true
      this.locked = true
      this.table.loading = false
      this.table.noDataText = this.$i18n.t('dishes.warningArea')
    } else {
      await this.load({
        limit: -1,
        skip: 0,
        area: this.$store.state.area.id,
        subrecipe: false,
        sort: 'name',
        status: 'attached'
      })
    }
  },
  computed: {
    sections: function () {
      return this.$store.state.sections || []
    },
    area: function () {
      return this.$store.state.area.id
    }
  },
  watch: {
    area: async function (val) {
      await this.load({
        limit: -1,
        skip: 0,
        area: val,
        subrecipe: false,
        sort: 'name',
        status: 'attached'
      })
    },
    'search': async function (val) {
      const params = {
        limit: this.table.options.itemsPerPage,
        area: this.$store.state.area.id,
        skip: (this.table.options.itemsPerPage * (this.table.page - 1)),
        sort: 'name',
        subrecipe: false
      }
      if (val.length >= 3) {
        try {
          params.name = new RegExp(val, 'i')
          let content = this.dishes
          if (this.sectionSelected && this.sectionSelected.id) {
            content = content.filter(x => {
              if (x.section) {
                return x.section.id === this.sectionSelected.id
              }
              return false
            })
          }
          content = content.filter(x => params.name.test(x.name))
          this.table.data.models = content
          this.table.total = content.length
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      } else {
        await this.filterBySection(this.sectionSelected)
      }
    }
  },
  methods: {
    onToggleSelect (data) {
      this.selected = []
      if (data.value) {
        this.dishes.map(dish => {
          const item = dish.clone()
          this.selected.push(item)
        })
      }
    },
    setError (type, item, error) {
      if (error) {
        const index = this.errors.findIndex(i => i.uuid === item.$.uuid)
        if (index < 0) {
          this.errors.push(item.$)
        }
      } else {
        const index = this.errors.findIndex(i => i.uuid === item.$.uuid)
        if (index >= 0) {
          this.errors.splice(index, 1)
        }
      }
    },
    priceToPercent (price, cost) {
      const percent = price ? (((1 * cost) / price) * 100).toFixed(2) : 0
      return isFinite(percent) ? Number(percent) : 0
    },
    percentToPrice (percent, cost) {
      const price = percent ? ((1 / (percent / 100)) * cost).toFixed(2) : 0
      return isFinite(price) ? Number(price) : 0
    },
    calculatePrice (event, item) {
      if (!isNaN(Number(event))) {
        item.price = this.percentToPrice(event, item.cost)
        item.percent = event
        this.changeItemQuantity(event, item)
      } else {
        item.percent = event
      }
    },
    calculatePercent (event, item) {
      if (!isNaN(Number(event))) {
        item.percent = this.priceToPercent(event, item.cost)
        item.price = event
        this.changeItemQuantity(event, item)
      } else {
        item.price = event
      }
    },
    changeItemQuantity (event, item) {
      const index = this.selected.findIndex(obj => obj.uuid === item.uuid)
      if (index >= 0 && item.quantity > 0) {
        this.selected[index] = item
      } else if (index >= 0 && item.quantity < 0) {
        this.selected.splice(index, 1)
      } else {
        this.selected.push(item)
      }
    },
    updateTable: async function (data) {
      const { sortBy, sortDesc } = data
      const start = data.itemsPerPage * (data.page - 1)
      const end = data.itemsPerPage * data.page
      const sortParam = (sortDesc > 0 ? '' : '-') + sortBy
      this.table.data.models = _.sortBy(this.dishes, sortParam).slice(start, end)
    },
    async load (params = null) {
      params = params || {
        area: this.$store.state.area.id,
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        subrecipe: false,
        sort: 'name',
        status: 'attached'
      }
      this.overlay = true

      params.limit = 500
      try {
        const { response } = await this.recipeModel.fetch({ params })
        const recipes = response.data.data.map(recipe => {
          recipe.quantity = Math.ceil(recipe.avgWeeklySale * this.percentageSuggestedQuantity)
          return recipe
        })
        this.recipesList.replace([recipes])
        this.table.data = this.recipesList

        this.dishes = response.data.data.map(item => {
          const updatedDish = this.selected.find(dish => dish.uuid === item.uuid)
          const quantity = updatedDish ? updatedDish.quantity : item.quantity || 1
          const dish = Object.assign(
            item,
            {
              price: item.price.toFixed(2),
              percent: this.priceToPercent(item.price, item.cost),
              quantity: quantity
            }
          )
          return new Recipe(dish)
        })
        await this.updateTable({
          sortBy: 'name',
          sortDesc: 1,
          itemsPerPage: this.table.options.itemsPerPage,
          page: this.table.options.page
        })
        this.table.total = response.data.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    fetch: async function (entity, params) {
      return this.$api.get(`/v1/${entity}`, params)
    },
    async update () {
      this.$refs.prospections.validate()
      if (!this.isValid || this.errors.length) {
        const errors = this.errors.map(error => `</br>${error.name}`)
        this.$toasted.show(
          `Existen datos vacios en los productos: ${errors}`,
          {
            action: {
              text: 'Cerrar',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            }
          }
        )
      } else {
        this.overlay = true
        const area = this.$store.state.area
        try {
          const payload = {
            area: area.id,
            recipes: this.selected.map(recipe => {
              return { recipe: recipe.uuid, price: recipe.price, quantity: recipe.quantity }
            })
          }
          this.prospection.set(payload)
          const { response } = await this.prospection.create()
          this.prospection.set(response.data)
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    calculateTheoricCost (product) {
      return product.quantityRequested * product.amount
    },
    calculateDifference (product) {
      return product.input.quantityAvailable - product.input.quantityCalculated
    },
    filterBySection (section) {
      this.sectionSelected = section
      const area = this.$store.state.area
      let filteredItems
      this.table.loading = true
      if (section.id) {
        filteredItems = this.dishes.filter(item => item.section.id === section.id && item.area.id === area.id)
        this.table.total = filteredItems.length
      } else {
        const start = this.table.options.itemsPerPage * (this.table.options.page - 1)
        const end = this.table.options.itemsPerPage * this.table.options.page
        filteredItems = this.dishes.filter(item => item.area.id === area.id).slice(start, end)
        this.table.total = this.dishes.length
      }
      this.table.data.models = _.sortBy(filteredItems, 'name')
      this.table.loading = false
    },
    openUpdateIngredientsDialog: function (recipe) {
      this.recipe = recipe.$
      this.ingredientDialog = true
    },
    async closeIngredientDialog () {
      this.ingredientDialog = false
      await this.load()
    },
    async sortDescTable (data) {
      if (!data) return
      this.dishes = this.dishes.reverse()
      await this.updateTable({
        sortBy: this.sortAttrName,
        sortDesc: -1,
        itemsPerPage: this.table.options.itemsPerPage,
        page: this.table.options.page
      })
    },
    async sortByTable (data) {
      if (!data) return
      const floatColumns = [
        'cost', 'avgWeeklySale', 'percent', 'quantity', 'price'
      ]
      this.dishes = this.dishes.sort((a, b) => {
        a = _.get(a, data)
        b = _.get(b, data)
        if (floatColumns.includes(data)) {
          a = parseFloat(a)
          b = parseFloat(b)
        }
        if (a > b) return 1
        if (a < b) return -1
        return 0
      })
      this.sortAttrName = data
      await this.updateTable({
        sortBy: data,
        sortDesc: 1,
        itemsPerPage: this.table.options.itemsPerPage,
        page: this.table.options.page
      })
    }
  }
}
</script>
